<div class="contact_container page-container">
  <div *ngIf="isLoaderVisible">
    <app-loader></app-loader>
  </div>
  <div class="contact-wrapper">
    <div class="contact-details">
      <h1>{{'letsChat' | translate}}</h1>
      <p>{{'tellMoreAboutIdea' | translate}}</p>
      <p style="margin-top: 5%">lupulcreativ&#64;gmail.com</p>
      <p>+40 740 241 423</p>
      <div class="wave-painting-divider">
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 1200" preserveAspectRatio="none">
          <path d="M56.44,321.39c-10.79,58-30.13,114.16-41.86,172-16.72,82.39-17.73,168.19-.39,250.45,17.73,82.39,58.73,165.28,79.56,244.27,18.48,70.05,26.09,146.53,3,214.34H0V0H27.35A600.21,600.21,0,0,1,56.44,321.39Z" class="shape-fill"></path>
        </svg>
      </div>
    </div>
    <div class="contact-form">
      <form [formGroup]="myForm">
        <div class="full-width flex">
          <mat-form-field class="half-width">
            <mat-label>{{'orderFormFirstname' | translate}}</mat-label>
            <input matInput [formControl]="firstNameFormControl">
            <mat-error *ngIf="firstNameFormControl.hasError('required')">
              {{'orderFormFirstNameIs' | translate}} <strong>{{'required' | translate}}</strong>
            </mat-error>
          </mat-form-field>
          <mat-form-field class="half-width">
          <mat-label>{{'orderFormLastname' | translate}}</mat-label>
          <input matInput [formControl]="lastNameFormControl">
          <mat-error *ngIf="lastNameFormControl.hasError('required')">
            {{'orderFormLastnameIs' | translate}}s <strong>{{'required' | translate}}</strong>
          </mat-error>
        </mat-form-field>
        </div>

        <mat-form-field class="full-width">
          <mat-label>{{'orderFormEmail' | translate}}</mat-label>
          <input type="email" matInput [formControl]="emailFormControl" placeholder="pat@example.com">
          <mat-error *ngIf="emailFormControl.hasError('email') && !emailFormControl.hasError('required')">
            {{'orderFormEmailMustBeValid' | translate}}
          </mat-error>
          <mat-error *ngIf="emailFormControl.hasError('required')">
            {{'orderFormEmailIs' | translate}} <strong>{{'required' | translate}}</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width">
          <mat-label>{{'orderFormTelephone' | translate}}</mat-label>
          <input type="tel" matInput placeholder="0744444444" [formControl]="telephoneFormControl" >
          <mat-error *ngIf="telephoneFormControl.hasError('required')">
            {{'orderFormTelephoneIs' | translate}} <strong>{{'required' | translate}}</strong>
          </mat-error>
          <mat-error *ngIf="telephoneFormControl.hasError('pattern')">
            {{'orderFormTelephoneError' | translate}}
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width">
          <mat-label>{{'orderFormMessage' | translate}}</mat-label>
          <textarea matInput placeholder="{{'orderFormMessagePlaceholder' | translate}}." [(ngModel)]="otherDetails" [ngModelOptions]="{standalone: true}"></textarea>
        </mat-form-field>

        <mat-checkbox [formControl]="termsAndConditionsControl" class="full-width" color="primary">{{'agreeWith' | translate}}<a>{{'termsAndConditions' | translate}}</a></mat-checkbox>
        <mat-checkbox [formControl]="confidentialityPolicyControl" class="full-width" color="primary">{{'agreeWithDataProcessing'|translate}}</mat-checkbox>

        <p *ngIf="isMailSent" class="success-message full-width">{{'requestSentSuccessfully' | translate}}</p>

        <div class="flex flex-center" style="margin-top: 5%">
          <button mat-raised-button class="contrast-button" (click)="sendIdea()" [disabled]="myForm.invalid || isMailSent">{{'sendOffer' | translate}}</button>
        </div>
      </form>
    </div>
  </div>
  <div class="bottom-gradient"></div>
</div>
